import { render, staticRenderFns } from "./TextDivider.vue?vue&type=template&id=7380c1d2&scoped=true&"
import script from "./TextDivider.vue?vue&type=script&lang=js&"
export * from "./TextDivider.vue?vue&type=script&lang=js&"
import style0 from "./TextDivider.vue?vue&type=style&index=0&id=7380c1d2&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7380c1d2",
  null
  
)

export default component.exports